import Vue from 'vue'
import Router from 'vue-router'
import moduleRouter from './fileLoad'
import routerData from './mould'

import vueResource from 'vue-resource'

Vue.use(Router)
Vue.use(vueResource)

export default new Router({
  base: '/',
  routes: [{
    path: '/',
    name: routerData.index.name,
    component: moduleRouter.index
  }, {
    path: routerData.index.path,
    redirect: '/'
  }, {
    path: routerData.information.path,
    name: routerData.information.name,
    component: moduleRouter.information
  }, {
    path: routerData.informationcon.path,
    name: routerData.informationcon.name,
    component: moduleRouter.informationcon
  }, {
    path: routerData.inorganic.path,
    name: routerData.inorganic.name,
    component: moduleRouter.inorganic
  }, {
    path: routerData.boutique.path,
    name: routerData.boutique.name,
    component: moduleRouter.boutique
  }, {
    path: routerData.boutiquecon.path,
    name: routerData.boutiquecon.name,
    component: moduleRouter.boutiquecon
  }, {
    path: routerData.statistics.path,
    name: routerData.statistics.name,
    component: moduleRouter.statistics
  }, {
    path: routerData.notFind.path,
    name: routerData.notFind.name,
    component: moduleRouter.notFind
  }, {
    path: routerData.mindex.path,
    name: routerData.mindex.name,
    component: moduleRouter.mindex
  }, {
    path: routerData.minformation.path,
    name: routerData.minformation.name,
    component: moduleRouter.minformation
  }, {
    path: routerData.minorganic.path,
    name: routerData.minorganic.name,
    component: moduleRouter.minorganic
  }, {
    path: routerData.minformationcon.path,
    name: routerData.minformationcon.name,
    component: moduleRouter.minformationcon
  }, {
    path: routerData.mboutique.path,
    name: routerData.mboutique.name,
    component: moduleRouter.mboutique
  }, {
    path: routerData.boutiquecon1.path,
    name: routerData.boutiquecon1.name,
    component: moduleRouter.boutiquecon1
  }, {
    path: routerData.mboutiquecon.path,
    name: routerData.mboutiquecon.name,
    component: moduleRouter.mboutiquecon
  }, {
    path: routerData.mboutiquecon1.path,
    name: routerData.mboutiquecon1.name,
    component: moduleRouter.mboutiquecon1
  }, {
    path: routerData.mstatistics.path,
    name: routerData.mstatistics.name,
    component: moduleRouter.mstatistics
  }]
})



// WEBPACK FOOTER //
// ./src/router/router.js